import {Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {IonicModule, ModalController} from '@ionic/angular';
import {SubService} from '../../services/sub.service';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {ArbameService} from '../../services/arbame.service';
import {ToastService} from '../../services/toast.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-mini-cart',
  templateUrl: './mini-cart.component.html',
  styleUrls: ['./mini-cart.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    NgForOf,
    NgIf,
  ],
})
export class MiniCartComponent implements OnInit {
  cartData: any = [];
  totalPrice = 0;

  @Output() closeMenu: EventEmitter<any> = new EventEmitter<any>();
  appInitData;

  constructor(@Inject(PLATFORM_ID) public platformId: any, private router: Router, private modalCtrl: ModalController, private sub: SubService, private aService: ArbameService, private ts: ToastService) {
    this.sub.cart.subscribe((data) => {
      if (data) {
        this.cartData = data;
        this.currentCartId = data.id;

      }
    });
    this.sub.appInitData.subscribe((data => {
      this.appInitData = data;
    }));
    this.sub.reloadBasket.subscribe((data) => {
      if (data) {
        this.cartData = null;
        this.getCart();
        this.sub.reloadBasket.next(false)
      }
    });
    this.sub.emptyBasket.subscribe((data) => {
      if (data) {
        this.cartData = null;
      }
    });
  }

  cartLoading = false;
  currentCartId;
  basketEmpty = false;

  getCart() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    if (!this.cartData?.data) {
      this.cartLoading = true;
    }

    if (localStorage.getItem('cgi')) {
      this.currentCartId = localStorage.getItem('cgi');
      this.aService.getCart(localStorage.getItem('cgi'), null).subscribe((data) => {
        this.cartLoading = false;
        this.cartData = data.data;
        if (data.data.length === 0) {
          this.basketEmpty = true;
        }
      }, error => {
        localStorage.removeItem('cgi');
        this.basketEmpty = true;
        this.cartLoading = false;
      });
    } else {
      this.cartLoading = false;
      this.basketEmpty = true;
    }
  }

  ngOnInit() {
    this.getCart();
  }

  dismiss() {
    this.closeMenu.emit(true);
  }

  softLoadingCart = false;

  deleteItem(item: any, i: number) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const fd = new FormData();
    this.currentCartId = localStorage.getItem('cgi');
    fd.append('cart_group_id', this.currentCartId);
    fd.append('product_id', item.product_id);
    this.softLoadingCart = true;
    this.cartData.cart_items.splice(i, 1);
    this.aService.deleteFromCart(fd).subscribe((data) => {
      this.softLoadingCart = false;
      this.cartData = data.data.cart_group;
      this.appInitData.data.cart_items_count = data.data.cart_group.cart_items.length;
      this.sub.appInitData.next(this.appInitData);
      this.sub.countCart.next(data?.data?.cart_group?.cart_items?.length ? data?.data?.cart_group?.cart_items?.length : 0);
      if (data.data.length === 0) {
        this.basketEmpty = true;
      }
    }, error => {
      this.softLoadingCart = false;
      this.basketEmpty = true;
      this.cartLoading = false;
    });
  }

  redirectToCart() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.router.navigate(['/basket/' + localStorage.getItem('cgi')]);
    this.dismiss();
  }

  subInterval;

  subItemQty(item, i) {

    if (item.subCount) {
      if ((+item.amount - +item.subCount) > 1) {
        item.subCount = +item.subCount + 1;
      }
    } else {
      item.subCount = 1;
    }
    if (item.timeOut) {
      clearTimeout(item.timeOut);
    }

    if ((+item.amount - +item.subCount) === 0) { // check for delete if 0
      this.deleteItem(item, i);
      return;
    }
    item.timeOut = setTimeout(() => {
      this.subInterval = setInterval(() => {
        item.subCount--;
        item.amount = +item.amount - 1;
        if (item.subCount <= 0) {
          clearInterval(this.subInterval);
          this.addToCart(item);
        }
      }, 80);
    }, 1000);
  }

  addInterval;
  prevousAddCount;

  addItemQty(item) {
    this.prevousAddCount = item.amount;
    if (item.addCount) {
      item.addCount = +item.addCount + 1;
    } else {
      item.addCount = 1;
    }
    if (item.timeOut) {
      clearTimeout(item.timeOut);
    }
    item.timeOut = setTimeout(() => {
      this.addInterval = setInterval(() => {
        item.addCount--;
        item.amount = +item.amount + 1;
        if (item.addCount <= 0) {
          clearInterval(this.addInterval);
          this.addToCart(item);
        }
      }, 80);
    }, 1000);
  }

  addToCart(item) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const fd = new FormData();
    fd.append('product_id', item.product_id);
    fd.append('amount', item.amount);
    let groupId = localStorage.getItem('cgi');
    if (groupId) {
      fd.append('cart_group_id', groupId);
    }
    this.softLoadingCart = true;
    this.aService.setAmountToCartItem(fd).subscribe((data) => {
      this.softLoadingCart = false;
      localStorage.setItem('cgi', data.data.cart_group.id);
      this.sub.cart.next(data.data.cart_group);
      this.sub.countCart.next(data?.data?.cart_group?.cart_items?.length ? data?.data?.cart_group?.cart_items?.length : 0);
    }, error => {
      if (error.error.message === 'out of stock') {
        this.ts.ErrorToast('Out of Stock');
      }
      item.amount = this.prevousAddCount;
    });
  }
}
